// Bookie · Olxo'ri Guli — Hanami blossom-viewing engagement
// (Round-9 rewrite). The HTML at /templates/bookie-plum.html is now
// a Japanese hanami-engagement layout — full-bleed plum-blossom
// hero photo, invitation card with Konyaku kanji, a three-step
// hanami tea program (Sencha / Matcha / Sakura-yu), a three-blossom
// gallery (ume / sakura / momo), details, RSVP form, and a
// Japanese closing blessing. Cream paper + plum + warm gold,
// Marcellus display, Shippori Mincho for Japanese accents,
// Cormorant Garamond italic body, Manrope eyebrows. The motif is
// still the plum-blossom branch curl. Music DROPPED per spec
// (contemplative ritual) — we no longer forward an audio param.
//
// We pass payload values via the URL because postMessage would race
// the iframe's first paint and the customizer needs to run before
// the IntersectionObserver inside the HTML attaches.

import type { VariantProps } from "./types";
import { getLocale } from "@/lib/i18n";

const TEMPLATE_HTML = "/templates/bookie-plum.html";

export function BookiePlumStaticVariant({ t, ctx }: VariantProps) {
  const params = new URLSearchParams();
  if (t.names) params.set("names", t.names);
  if (t.date) params.set("date", t.date);
  if (t.venue) params.set("venue", t.venue);
  if (t.address) params.set("address", t.address);
  if (t.time) params.set("time", t.time);
  // Demo / preview surfaces (gallery thumbnail, editor preview)
  // leave ctx.slug undefined. The flag is kept harmlessly for future
  // demo-only embellishments; the current HTML does not branch on it.
  // Real published invitations: forward the public slug so the
  // HTML's RSVP submitter can POST to /api/v1/public/i/<slug>/rsvp.
  if (ctx.slug) params.set("slug", ctx.slug);
  // Music intentionally NOT forwarded — the hanami variant is a
  // contemplative ritual (silent tea ceremony) and the iframe no
  // longer has an audio handler. If t.musicTrackId is set in data
  // it's simply ignored here.
  // Cache buster — bump when the static HTML changes. Vite doesn't
  // hash files in public/, so without a query string the browser
  // caches the file and skips updates.
  params.set("v", "3");

  // Demo/catalog preview (no real invitation slug): default the template's
  // in-iframe language to the app locale, so taklifla.com previews render in
  // English (and a RU viewer sees Russian). The HTMLs read ?lang= (all) and
  // ?default_lang= (newer premium ones) — set both. Owner-published
  // invitations (ctx.slug set) keep their own default_lang / built-in default.
  if (!ctx.slug) {
    const _loc = getLocale();
    if (!params.has("lang")) params.set("lang", _loc);
    if (!params.has("default_lang")) params.set("default_lang", _loc);
  }
  const src = `${TEMPLATE_HTML}?${params.toString()}`;

  return (
    <iframe
      src={src}
      title={t.names || "Olxo'ri Guli"}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100svh",
        border: "none",
        display: "block",
        background: "#FBF4EC",
      }}
    />
  );
}
